import { render, staticRenderFns } from "./search_mobile.vue?vue&type=template&id=5dd962b7&scoped=true&"
import script from "./search_mobile.vue?vue&type=script&lang=js&"
export * from "./search_mobile.vue?vue&type=script&lang=js&"
import style0 from "./search_mobile.vue?vue&type=style&index=0&id=5dd962b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd962b7",
  null
  
)

export default component.exports